module.exports = __webpack_public_path__ + "static/media/transaction.21ce10a5.png";